import Section from './MainPage'
import isEmpty from './MainPageIsEmpty'

export default { Section, isEmpty }
